module.exports = __webpack_public_path__ + "img/gb9117_3.prt.90b5f280.jpg";